varying vec2 vUv;

uniform sampler2D uHeightMap;
uniform float uHeightScale;

void main() {
  vec3 localPosition = position;
  float height = texture2D(uHeightMap, uv).r;
  
  localPosition.z += height * uHeightScale;

  gl_Position = projectionMatrix * modelViewMatrix * vec4(localPosition, 1.0);


  vUv = uv;
}